import { Box } from '@mui/material';
import { LoadPanel } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PricelistApis } from '../../hooks/apis/PricelistApis';
import { IClient } from '../../interfaces/ElementModels/IClient';
import PageTitle from '../components/PageTitle';
import ClientBox from './components/ClientBox/ClientBox';
import './Pricelists.scss';

const Pricelists = () => {
  const { getAvailablePricelists } = PricelistApis();
  const [pricelists, setPricelists] = useState<IClient[]>(null);
  const [pricelistLoading, setPricelistLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>(null);

  useEffect(() => {
    getAvailablePricelists().then((data) => {
      if (!data.Message) {
        setPricelists(data);
      } else {
        setErrorMessage(data.Message);
      }
      setPricelistLoading(false);
    });
  }, [getAvailablePricelists]);

  return (
    <>
      <PageTitle pageTitle="Pricelists" titleText="Available Pricelists" />

      <LoadPanel height={100} width={250} message="Collecting available pricelists" visible={pricelistLoading} />

      {!pricelistLoading && !errorMessage && pricelists?.length === 0 ? (
        <Box>
          No Pricelists currently available head to <Link to="/profile">profile</Link> to request access
        </Box>
      ) : null}
      {!pricelistLoading && errorMessage ? <Box>{errorMessage}</Box> : null}
      {!pricelistLoading && pricelists?.length > 0 ? (
        <Box className="availablePricelists">
          {pricelists?.map((m) => (
            <ClientBox key={m.ClientID} clientData={m} />
          ))}
        </Box>
      ) : null}
    </>
  );
};

export default Pricelists;
